import React, { useState, useEffect } from "react"
import axios from "axios"
import { Auth } from "aws-amplify";
import { Divider, FormControl, InputLabel, MenuItem, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { useTranslation } from 'react-i18next';

import FilterListIcon from '@mui/icons-material/FilterList';

import FileTile from "../../FileTile"

const Intervention = ({ facInfo }) => {
  const [fileData, setFileData] = useState("")
  const [testId, setTestId] = useState(facInfo.allTests ? facInfo.allTests[0].testId : null)
  const [lang, setLang] = useState( facInfo.allTests ? facInfo.allTests[0].lang.sort()[0] : null);

  const { t } = useTranslation();
  
  useEffect(() => {
    if(facInfo.allTests){
      Auth.currentSession()
      .then((data) => {
        const jwtToken = data.idToken.jwtToken;
        
        const getFileData = async(testId, facId, adminId, std) => {
          try {
            const response =  await axios.get("https://zk1128nq2f.execute-api.ap-south-1.amazonaws.com/alpha/facilitator/"+facId+"/file?adminId="+adminId+"&testId="+testId, {
              headers: {
                'Content-Type': 'application/json',
                'Authorization': jwtToken
              }
            });
            const fileData = response.data["file"]
            // console.log("File Data: ", fileData)
            const filteredFileData = fileData.allFiles.filter(item => item.std === std)  // change required to make it work for multiple stds and schools
            setFileData(filteredFileData.map(item => ({...item, viewed: fileData.viewedFiles.includes(item.fileId) })))  // marking viewed true for fileIds whose count is already there in db
          }
          catch (error) {
            console.log(error)
          }
        }
        
        const facId = facInfo.facilitator[0].facId;
        const adminId = facInfo.facilitator[0].adminId
        const std = facInfo.facilitator[0].schools[0].classes[0].std
        // console.log("facId and adminId: ", facId, adminId)
        getFileData(testId, facId, adminId, std)
        
      })
      .catch((err) => console.log(err));
    }
    else{
      alert(t("commonItems.error_noTestCompleted"))
      window.location.replace("/");
    }
    
  }, [t, facInfo, testId]);

  const handleTestIdChange = (e) => {
    setFileData("");
    let selectedTestLangs = facInfo.allTests.filter(item => item.testId === e.target.value)[0].lang
    if(!selectedTestLangs.includes(lang)) setLang(selectedTestLangs.sort()[0])
    setTestId(e.target.value);
  };
  
  const handleLangChange = (e) => {
    setLang(e.target.value);
  };
  
  return (
    <div className="InterventionContent innerContent">
      <h2 style={{textAlign: "center", color: "#0288D1", borderRadius: "15px", border: "1px solid"}}>{t("facilitator.intervention.title")}</h2>
      <div className="filters">
        <div className="forms">
          <h4 style={{display: "flex", justifyContent: "center", alignItems: "center", gap: "0.25rem"}}>
            <FilterListIcon fontSize="small"/>
            <span style={{height: "100%"}}>{t("commonItems.filterLabel")}</span> 
          </h4>
          <FormControl sx={{ m: 1, minWidth: 150}} size="small">
            <InputLabel id="testNameFilterLabel">{t("commonItems.dropdownLabel_testName")}</InputLabel>
            <Select
              labelId="testIdFilterLabel"
              id="testIdFilter"
              value={testId ? testId : ""}
              onChange={handleTestIdChange}
              autoWidth
              label={t("commonItems.dropdownLabel_testName")}
            >
              {/* <MenuItem value="">
                <em>None</em>
              </MenuItem> */}
              {/* getting all unique std values from data */}
              {facInfo.allTests &&
                facInfo.allTests.map(item => item.testName).map((item, i) => {
                return <MenuItem key={i} value={facInfo.allTests[i].testId}>{item}</MenuItem>
                })
              }
            </Select>
          </FormControl>
          <FormControl sx={{ m: 1, minWidth: 120}} size="small">
            <InputLabel id="langFilterLabel">{t("commonItems.dropdownLabel_lang")}</InputLabel>
            <Select
              labelId="langFilterLabel"
              id="langFilter"
              value={lang}
              onChange={handleLangChange}
              autoWidth
              label={t("commonItems.dropdownLabel_lang")}
            >
              {facInfo.allTests &&
                facInfo.allTests.filter(item => item.testId === testId)[0].lang.sort().map((item, i) => {
                  return <MenuItem key={i} value={item}>{facInfo.allLangs[item]}</MenuItem>   
                })
              }
            </Select>
          </FormControl>
        </div>
      </div>
      <div style={{display: "flex", flexWrap: "wrap", alignItems: "center", gap: "0.5rem"}}>
        <div style={{display: "flex", alignItems: "center", gap: "0.5rem"}}>
          <span style={{backgroundColor: "rgb(255 181 181 / 30%)", display: "inline-flex", width: "40px", height: "15px"}}></span>
          <p className="fontFamily-Montserrat">{t("commonItems.interventionCat1")}</p>
        </div>
        <div style={{display: "flex", alignItems: "center", gap: "0.5rem", marginLeft: "0.5rem"}}>
          <span style={{backgroundColor: "rgb(170 234 203 / 30%)", display: "inline-flex", width: "40px", height: "15px"}}></span>
          <p className="fontFamily-Montserrat">{t("commonItems.interventionCat2")}</p>
        </div>
      </div>
      {fileData && 
        <div className="table" style={{marginTop: "1rem"}}>
          <Divider />
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell align="center" style={{padding: "12px" }}><h4>{t("facilitator.intervention.tableHeader_title")}</h4></TableCell>
                  {/* <TableCell align="center" style={{padding: "12px" }}><h4>Language</h4></TableCell> */}
                  <TableCell align="center" style={{width: "350px", padding: "12px" }}><h4>{t("facilitator.intervention.tableHeader_view")}</h4></TableCell>
                  <TableCell align="center" style={{ padding: "12px" }}><h4>{t("facilitator.intervention.tableHeader_download")}</h4></TableCell>
                  {/* <TableCell align="center" style={{width: "100px", padding: "12px" }}><h4>Downloaded/ Watched</h4></TableCell> */}
                </TableRow>
              </TableHead>
              <TableBody>
                {(!fileData.length || !fileData.filter(item => item.lang === lang).length) && 
                  <TableRow hover>
                    <TableCell align="center" colSpan={5}>{t("facilitator.intervention.error_interventionNotFound")}</TableCell>
                  </TableRow>
                }
                {
                  fileData.filter(item => item.lang === lang).map(item => {
                    return <FileTile key={item.fileId} fileInfo={item} testId={testId} facId={facInfo.facilitator[0].facId} classId={facInfo.facilitator[0].schools[0].classes[0].classId} />
                  })
                }
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      }
    </div>
  )
}

export default Intervention